module.exports = __webpack_public_path__ + "img/cnnturk.951c4c90.png";